import React from 'react';
import styled from 'styled-components';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip ,ResponsiveContainer} from 'recharts';
import {Consumer} from '../../context/InfoContext';
import Row from '../../dev/Row';
import Span from '../../dev/Span';
//assets
import { EyeGray } from './Eye'
import { EngageGray } from './Engage'


const RecentBarCharts = (props) => {
    return (
        <Consumer>{value=> {
            const { recentVideos, twoMonthVideos } = value       /*PM:這邊應該要做一下傳進來的是兩個月還二十支 */
            return (
                <ResponsiveContainer>
                    <BarChart 
                        data={(props.dataType==='近二十支影片')?recentVideos:twoMonthVideos} /*PM:這邊做一下是兩個月還二十支 */
                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                        barSize={14} 
                        barGap={10} 
                    >
                        <CartesianGrid strokeDasharray="10 3" vertical={false} />
                        <XAxis hide/>
                        <YAxis 
                            axisLine={false} 
                            ticks={props.ticks}
                            domain={[0,props.maxData]}
                        />
                        <Tooltip
                            content={<ChartContent/>}
                            animationDuration={100}
                            cursor={false}//設flase 自己寫比較快
                            wrapperStyle={ {zIndex: 1000 }}//不會被下方bar遮到」
                        />
                        <Bar 
                            dataKey={props.dataKey} 
                            onClick={(e) => window.open('https://www.youtube.com/watch?v=' + e.payload.videoId, '_blank')}
                            minPointSize={5}
                            style={{
                                cursor: 'pointer',
                                fill: 'rgba(222, 6, 6, 0.5)',
                            }}
                    />
                    </BarChart>
                </ResponsiveContainer>
        )}}</Consumer>
    );
}

const ChartContent = (props) => {
    if(props.payload[0] === undefined) { return null }
    const data = props.payload[0].payload
    // console.log(data)
    return (
        <CharContentLayout>
            <Row>
                <Row>
                    <VideoLayout image={data.cover}/>
                </Row>
                <Row direction='column'>
                    <Row>
                        <Span youtubeRed weight='500'>{data.publishAt}</Span>
                    </Row>
                    <Row>
                        <Row direction='column' width='15px' height='35px' padding='4px 0 3px 0' item='center' content='space-between'>
                            <EyeGray/>
                            <EngageGray/>
                        </Row>
                        <Row direction='column'>
                            <Span>{data.viewCount}</Span>
                            <Span>{data.engageRate}%</Span>
                        </Row>
                    </Row>
                </Row>
            </Row>
            <Row padding='10px 10px 0 10px'>
                <Span>{data.title}</Span>
            </Row>
        </CharContentLayout>
    )
}
ChartContent.defaultProps = { payload: [] }

export default RecentBarCharts;


const CharContentLayout = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 220px;
    height: auto;
    padding: 10px;
    font-size: 1px;
    background-color: #fff;
    box-shadow: 0 1px 4px 0 #787878;
    z-index: 100;
`
const VideoLayout = styled.div`
    position: relative;
    width: 96px;
    height: 54px;
    margin-right: 10px;
    background: url('${props => props.image}');   
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
`



// WEBPACK FOOTER //
// ./src/Info/Recent/RecentBarChart.js